import React from 'react';
import { graphql } from 'react-relay';
import { Query } from '../../index';
import { populateChildren } from '../toolbox';

const QGetAllFramesQuery = graphql`
  query QGetAllFramesQuery($offerIds: [ID!]) {
    allFrames(offerIds: $offerIds) {
      id
      name
      pdfIds
      teamId
      offerId
      offerName
      metadata
      bundleTag
      version
      description
      isReferent
      versionFlexidocs
      comment
      who {
        creation
        lastUpdate
      }
      dates {
        creation
        lastUpdate
      }
      comparisons {
        id
        globalStatusResult
        when
        comparisonDetails {
          status
          diffPngsIds
          referentPdfId
          actualPdfId
          fileName
        }
      }
    }
  }
`;

const QGetAllFrames = ({
  children,
  childDataProp,
  args
}) => {
  return (
    <Query
      query={QGetAllFramesQuery}
      args={args}
      isCompareFrame
    >
      {populateChildren()(children, childDataProp)}
    </Query>
  );
};

export default QGetAllFrames;
